import { DEFINED_BY } from '~/scripts/constants/common-kids';
import Node from './node';

export default class Relation {
	/**
	 * @param {any} relation
	 */
	constructor(relation = undefined) {
		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.kid = relation.kid ?? DEFINED_BY;

		/** @type {string} */
		this.name = relation instanceof Node ? relation.getName() : relation.name ?? '';

		/** @type {?import('./link-style').default} */
		this.style = relation.kjson.style ?? null;

		/** @type {('link' | 'def')[]} */
		this.type = relation.kjson.type ?? [];
	}

	/**
	 * @returns {string}
	 */
	getName() {
		return this.name;
	}
}
